import React, { useContext, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { BrowseContext } from "../../../contexts/BrowseContext";
import { getCampaignStatus } from "../../Shared/ClientTimeline/clientCampaignStatus";
import ClientCampaignTimeline from "../../Shared/ClientTimeline/ClientCampaignTimeline";

export default observer(function ClientTimelineTab() {
  const { clientCampaigns } = useContext(BrowseContext);

  const { ongoing, ended } = useMemo(() => {
    const ongoing = [];
    const ended = [];
    clientCampaigns.forEach((c) => {
      const { label } = getCampaignStatus(c);
      if (label === "Finished") ended.push(c);
      else ongoing.push(c);
    });
    return { ongoing, ended };
  }, [clientCampaigns.length, clientCampaigns]);

  return (
    <div className="h-full">
      <ClientCampaignTimeline
        campaigns={ongoing}
        endedCampaigns={ended}
        title="Campaigns"
      />
    </div>
  );
});
